import { Clock, CheckCircle } from 'lucide-react';
import { Button } from '@components/ui';

export default function DailyNeedsWidget({ title, items, onItemAction, actionLabel, emptyMessage, formatCurrency }) {
    return (
        <div className="bg-bg-primary rounded-2xl border border-border-light overflow-hidden h-full flex flex-col">
            <div className="p-4 border-b border-border-light bg-bg-secondary/30 flex justify-between items-center">
                <h3 className="font-semibold text-text-primary flex items-center gap-2">
                    <Clock size={16} className="text-text-tertiary" />
                    {title}
                </h3>
                <span className="text-xs font-medium bg-bg-tertiary px-2 py-1 rounded-full text-text-secondary">
                    {items.length} adet
                </span>
            </div>

            <div className="divide-y divide-border-light overflow-y-auto max-h-[300px] scrollbar-thin">
                {items.length === 0 ? (
                    <div className="p-8 text-center text-text-muted text-sm flex flex-col items-center gap-2">
                        <CheckCircle size={24} className="text-success/50" />
                        {emptyMessage}
                    </div>
                ) : (
                    items.map((item) => (
                        <div key={item.id} className="p-4 hover:bg-bg-hover/50 transition-colors group">
                            <div className="flex items-center justify-between mb-2">
                                <div className="font-medium text-text-primary text-sm line-clamp-1">{item.title}</div>
                                <span className={`text-xs font-bold px-2 py-0.5 rounded ${item.isOverdue ? 'bg-error/10 text-error' : 'bg-warning/10 text-warning-dark'
                                    }`}>
                                    {item.isOverdue ? 'Gecikmiş' : 'Bugün'}
                                </span>
                            </div>

                            <div className="flex items-center justify-between">
                                <span className="text-xs text-text-secondary">{item.subtitle}</span>
                                <div className="font-bold text-text-primary">{formatCurrency(item.amount)}</div>
                            </div>

                            <div className="mt-3">
                                <Button
                                    size="sm"
                                    variant="outline"
                                    className="w-full text-xs h-8 hover:bg-success hover:text-white hover:border-success transition-colors"
                                    onClick={() => onItemAction(item)}
                                >
                                    {actionLabel}
                                </Button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
